var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AreaFilter from '@/components/SummaryFilters/AreaFilter/AreaFilter.vue';
import ExpansionPanelDialog from '@/components/dialog/ExpansionPanelDialog/ExpansionPanelDialog.vue';
import { RpcClient } from '@/http';
import { Period } from '@/models/Period';
import { Level } from '@/models/Level';
import EditTopicForAllDialog from './EditTopicForAllDialog/EditTopicForAllDialog.vue';
import EditAllTopicsForAllDialog from './EditAllTopicsForAllDialog/EditAllTopicsForAllDialog.vue';
import EditAllTopicsForStudentDialog from './EditAllTopicsForStudentDialog/EditAllTopicsForStudentDialog.vue';
import GraduationProfileSelect from '@/components/GraduationProfileSelect/GraduationProfileSelect.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { UserPreferences } from '@/models/UserPreferences';
import PeriodSelect from '@/components/PeriodSelect/PeriodSelect.vue';
import LevelSelect from '@/components/LevelSelect/LevelSelect.vue';
import AExpandableFilter from '@/components/AExpandableFilter/AExpandableFilter.vue';
import ConfirmationDialog from './ConfirmationDialog/ConfirmationDialog.vue';
let ChangeLevelAndPeriodeDialog = class ChangeLevelAndPeriodeDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.isFetchingTableData = false;
        this.selectedArea = '';
        this.tableHeaders = [];
        this.tableItems = [];
        this.tablePagination = {
            rowsPerPage: -1,
        };
        this.levels = [];
        this.periods = [];
        this.payload = {};
        this.filters = {
            graduationProfile: '',
            levels: '',
            periods: '',
        };
        this.isEditingAllTopicsForAll = false;
        this.isEditingTopicForAll = false;
        this.showConfirmationDialog = false;
        this.selectedTopicForAll = {};
        this.isEditingAllTopicsForStudent = false;
        this.selectedStudentForAllTopics = {};
        this.NON_TOPIC_HEADERS = ['name', 'id'];
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await Promise.all([this.fetchLevels(), this.fetchPeriods()]);
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onClose() {
        this.$emit('close');
    }
    onEditAllTopicsForAll() {
        this.isEditingAllTopicsForAll = true;
    }
    onEditTopicForAll(item) {
        this.isEditingTopicForAll = true;
        this.selectedTopicForAll = {
            value: item.value,
            text: item.text,
        };
    }
    onSubmitEditAllTopicsForAll(payload) {
        this.isEditingAllTopicsForAll = false;
        const topicIds = this.allTopics.map((t) => t.value);
        const studentIds = this.students.map((student) => student.id);
        this.updateTopicsForStudents(studentIds, topicIds, payload.levelId, payload.periodId);
    }
    onSubmitEditTopicForAll(payload) {
        this.isEditingTopicForAll = false;
        this.selectedTopicForAll = {};
        const topicIds = [payload.topicId];
        const studentIds = this.students.map((student) => student.id);
        this.updateTopicsForStudents(studentIds, topicIds, payload.levelId, payload.periodId);
    }
    onEditAllTopicsForStudent(item) {
        this.isEditingAllTopicsForStudent = true;
        this.selectedStudentForAllTopics = {
            id: item.id,
            name: item.name,
        };
    }
    onSubmitEditAllTopicsForStudent(payload) {
        this.isEditingAllTopicsForStudent = false;
        const topicIds = this.allTopics.map((topic) => topic.value);
        const studentId = [this.selectedStudentForAllTopics.id]; // must be an array
        this.updateTopicsForStudents(studentId, topicIds, payload.levelId, payload.periodId);
        this.selectedStudentForAllTopics = {};
    }
    // #endregion
    // #region Class methods
    updateTopicsForStudents(studentIds, topicIds, levelId, periodId) {
        topicIds.forEach((topicId) => {
            studentIds.forEach((studentId) => {
                this.setPayload(topicId, studentId, {
                    level: levelId,
                    period_order: periodId,
                });
                const tableItem = this.tableItems.find((item) => item.id === studentId);
                if (tableItem && tableItem[topicId]) {
                    tableItem[topicId].levels = levelId;
                    tableItem[topicId].periods = periodId;
                }
            });
        });
    }
    addUserIdToPayload(userId) {
        if (!this.payload.users || !Array.isArray(this.payload.users)) {
            this.$set(this.payload, 'users', []);
        }
        if (!this.payload.users.includes(userId)) {
            this.payload.users.push(userId);
        }
    }
    setPayload(subjectId, userId, data) {
        if (!this.payload[subjectId]) {
            this.payload[subjectId] = {};
        }
        if (!this.payload[subjectId][userId]) {
            this.payload[subjectId][userId] = {};
        }
        this.addUserIdToPayload(userId);
        Object.assign(this.payload[subjectId][userId], data);
    }
    setTableHeaders(topics) {
        this.tableHeaders = [
            {
                text: this.$tc('Student'),
                align: 'left',
                sortable: false,
                value: 'name',
            },
        ];
        Object.keys(topics).forEach((key) => {
            this.tableHeaders.push({
                text: topics[key],
                align: 'left',
                sortable: false,
                value: key,
            });
        });
    }
    setTableItems(users) {
        this.tableItems = [];
        const allTopicKeys = new Set();
        Object.values(users).forEach((user) => {
            if (user.topics) {
                Object.keys(user.topics).forEach((topicKey) => {
                    allTopicKeys.add(topicKey);
                });
            }
        });
        Object.keys(users).forEach((userId) => {
            const user = users[userId];
            const item = {
                id: userId,
                name: user.name,
            };
            allTopicKeys.forEach((topicKey) => {
                item[topicKey] =
                    user.topics && user.topics[topicKey] !== undefined
                        ? user.topics[topicKey]
                        : {};
            });
            if (user.topics && Object.keys(user.topics).length) {
                this.tableItems.push(item);
            }
        });
        this.tableItems.sort((a, b) => a.name.localeCompare(b.name));
    }
    updateLevel(user, subjectId, levelValue) {
        this.setPayload(subjectId, user.id, { level: levelValue });
    }
    updatePeriod(user, subjectId, periodValue) {
        this.setPayload(subjectId, user.id, { period_order: periodValue });
    }
    // #endregion
    // #region Async methods (api calls only)
    async onExcludeTopicForStudent(item, subjectId) {
        try {
            await new RpcClient().execute('update-preferences-for-users', {
                subjects: [subjectId],
                users: [item.id],
                state: 'excluded',
            });
            const tableItem = this.tableItems.find((tableItem) => tableItem.id === item.id);
            if (tableItem && tableItem[subjectId]) {
                tableItem[subjectId].state = 'excluded';
            }
            this.addUserIdToPayload(item.id);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onExcludeTopicForAll(item) {
        try {
            await new RpcClient().execute('update-preferences-for-users', {
                subjects: [item.value],
                users: this.students.map((student) => student.id),
                state: 'excluded',
            });
            this.students.forEach((student) => {
                this.addUserIdToPayload(student.id);
            });
            this.tableItems.forEach((tableItem) => {
                const topic = tableItem[item.value];
                if (!topic) {
                    return;
                }
                topic.state = 'excluded';
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onExcludeAllTopicsForStudent(user) {
        const keys = Object.keys(user);
        const topics = keys.filter((key) => key !== 'id' && key !== 'name');
        try {
            await new UserPreferences().user(user.id).put({
                subjects: topics,
                state: 'excluded',
            });
            topics.forEach((topic) => {
                if (!user[topic]) {
                    return;
                }
                user[topic].state = 'excluded';
            });
            this.addUserIdToPayload(user.id);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onIncludeTopic(user, subjectId) {
        try {
            await new UserPreferences().user(user.id).create({
                subject: subjectId,
                state: 'included',
            });
            user[subjectId].state = 'included';
            this.addUserIdToPayload(user.id);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onApplyFilters() {
        await this.fetchStudentOverview();
    }
    async fetchLevels() {
        try {
            this.levels = await new Level().all();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async fetchPeriods() {
        try {
            this.periods = await new Period().all();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async fetchStudentOverview() {
        this.isFetchingTableData = true;
        try {
            const response = await new RpcClient().execute('get-levels-periods-users', {
                area: this.selectedArea,
                users: this.students.map((student) => student.id),
                exit_profile: this.filters.graduationProfile ? this.filters.graduationProfile : '',
                levels: this.filters.levels ? this.filters.levels : '',
                periods: this.filters.periods ? this.filters.periods : '',
            });
            if (!response.topics ||
                !Object.keys(response.topics).length ||
                !response.users ||
                !Object.keys(response.users).length) {
                this.tableHeaders = [];
                this.tableItems = [];
                this.isFetchingTableData = false;
                return;
            }
            this.setTableHeaders(response.topics);
            this.setTableItems(response.users);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isFetchingTableData = false;
        }
    }
    async onSubmit() {
        this.showConfirmationDialog = true;
    }
    filterExcludedFromPayload() {
        Object.keys(this.payload).forEach((subjectId) => {
            this.tableItems.forEach((user) => {
                const userTopic = user[subjectId];
                if (userTopic && userTopic.state === 'excluded' && this.payload[subjectId][user.id]) {
                    delete this.payload[subjectId][user.id];
                }
            });
        });
    }
    async onSave(confirmationPayload) {
        this.filterExcludedFromPayload();
        this.showConfirmationDialog = false;
        this.payload.current_subjects_to_inactive = confirmationPayload;
        try {
            await new RpcClient().execute('update-levels-periods-users', this.payload);
            this.$emit('submitted');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get expansionPanelOptions() {
        return {
            title: this.$tc('Manage level and period'),
            description: this.$tc('Select the area for which you want to change the level and/or period. Then change the level and/or period for the students in this area.'),
            panels: [
                {
                    label: `1. ${this.$tc('Select area')}`,
                    slotName: 'panel1',
                    isOpen: true,
                    disabled: false,
                },
                {
                    label: `2. ${this.$tc('Change level and/or period')}`,
                    slotName: 'panel2',
                    isOpen: false,
                    disabled: this.selectedArea.trim().length === 0,
                },
            ],
        };
    }
    get allTopics() {
        return this.tableHeaders.filter((header) => !this.NON_TOPIC_HEADERS.includes(header.value));
    }
    // #endregion
    // #region @Watchers
    async onSelectedAreaChange() {
        this.payload.area = this.selectedArea;
        await this.fetchStudentOverview();
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], ChangeLevelAndPeriodeDialog.prototype, "students", void 0);
__decorate([
    Watch('selectedArea'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], ChangeLevelAndPeriodeDialog.prototype, "onSelectedAreaChange", null);
ChangeLevelAndPeriodeDialog = __decorate([
    Component({
        components: {
            ExpansionPanelDialog,
            AreaFilter,
            EditTopicForAllDialog,
            EditAllTopicsForAllDialog,
            EditAllTopicsForStudentDialog,
            LevelSelect,
            GraduationProfileSelect,
            PeriodSelect,
            AExpandableFilter,
            ConfirmationDialog,
        },
    })
], ChangeLevelAndPeriodeDialog);
export default ChangeLevelAndPeriodeDialog;
// #endregion
// #region Constants
// #endregion
